import { Editor } from 'tinymce'

/**
 * Box Types
 */
const boxTypes = {
	'mds-only-outline': { label: 'Nur Outline' },
	'mds-no-outline': { label: 'Ohne Outline' },
	'mds-only-background': { label: 'Nur Hintergrund' },
} as const;
const boxTypeKeys = Object.keys(boxTypes) as (keyof typeof boxTypes)[];

/**
 * Box Type Plugin
 */
export const registerBoxTypes = (editor: Editor) => {
	editor.ui.registry.addMenuButton('box-type', {
		icon: 'outline',
		tooltip: 'Box Typ',
		fetch: (cb, ctx, api) => {
			const node = editor.selection.getNode()?.closest('.mds-box-format');
			if (!node) return;

			const setTypeClass = (type?: keyof typeof boxTypes) => {
				const addClass = type ? !node.classList.contains(type) : false;
				node.classList.remove(...boxTypeKeys);
				if (addClass && type) node.classList.add(type);
				editor.dispatch('Change')
			};
			cb([
				{ 
					type: 'togglemenuitem', 
					value: 'normal', 
					text: 'Normal',
					onAction: () => setTypeClass(), 
					active: !node.className.match(new RegExp(`(${boxTypeKeys.join('|')})`))
				},
				...Object.entries(boxTypes).map(([key, entry]) => ({
					type: 'togglemenuitem' as const,
					value: 'box-format-' + key,
					text: entry.label,
					onAction: () => setTypeClass(key as keyof typeof boxTypes),
					active: node.classList.contains(key)
				}))
			]);
		}
	})
}